import { render, staticRenderFns } from "./HallsTab.vue?vue&type=template&id=5fe7e0b0&scoped=true&"
import script from "./HallsTab.vue?vue&type=script&lang=js&"
export * from "./HallsTab.vue?vue&type=script&lang=js&"
import style0 from "./HallsTab.vue?vue&type=style&index=0&id=5fe7e0b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe7e0b0",
  null
  
)

component.options.__file = "HallsTab.vue"
export default component.exports